module.exports = __webpack_public_path__ + "static/media/06.Prof.Vajra Kumara Abhinandana Award - Bhaska Kogga Kamath.fd5190af.jpg";